/** Suggest a stable field code from a human label. */
export const suggestFieldCode = (label) => {
  const raw = String(label || '').trim();
  if (!raw) return '';
  return raw
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_+/g, '_')
    .toUpperCase()
    .slice(0, 64);
};

export const suggestSectionCode = (name) => {
  const code = suggestFieldCode(name);
  return code || `SECTION_${Date.now().toString(36).toUpperCase()}`;
};

/** Ensure uniqueness within a list of existing codes. */
export const uniqueCode = (desired, existingCodes = []) => {
  const set = new Set((existingCodes || []).map((c) => String(c).toUpperCase()));
  let base = suggestFieldCode(desired) || 'FIELD';
  if (!set.has(base)) return base;
  let i = 2;
  while (set.has(`${base}_${i}`)) i += 1;
  return `${base}_${i}`;
};
